<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="zoom-button"
        :title="locateActive ? 'Skjul din posisjon' : 'Gå til din posisjon'"
        :aria-label="
          locateActive ? 'Skjul din posisjon' : 'Gå til din posisjon'
        "
        v-on="on"
        @click="toggleLocate"
      >
        <v-icon>{{
          locateActive ? "mdi-crosshairs-gps" : "mdi-crosshairs"
        }}</v-icon>
      </v-btn>
    </template>
    <span>{{
      locateActive ? "Skjul din posisjon" : "Gå til din posisjon"
    }}</span>
  </v-tooltip>
</template>

<script>
import { loadModules } from "esri-loader";
export default {
  name: "MapLocateButton",
  data: function() {
    return {
      locateButtonViewModel: null,
      locateActive: false,
    };
  },
  props: {
    kartview: Object,
  },
  methods: {
    toggleLocate() {
      this.locateActive
        ? this.locateButtonViewModel.cancelLocate()
        : this.locateButtonViewModel.locate();
      this.locateActive = !this.locateActive;
    },
    loadLocateButton: function() {
      loadModules(["esri/widgets/Locate/LocateViewModel"]).then(
        function([LocateViewModel]) {
          this.locateButtonViewModel = new LocateViewModel({
            view: this.kartview,
          });
          if (this.locateActive) {
            this.locateButtonViewModel.locate();
          }
        }.bind(this)
      );
    },
  },
  mounted() {
    this.loadLocateButton();
  },
};
</script>
